export default __webpack_public_path__ + "static/media/Selection_Customize.8d0775fd.svg";